// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
  StyledMobileBoxLabel,
} from '../../utils/Styles/DataBoxStyles';
import DollarOutput from '../../utils/DollarOutput';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ExpensesMobile = ({ expenses }) => {
  return (
    <div>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {expenses.map(expense => (
        <StyledMobileBoxItem key={expense.expenseId}>
          <StyledMobileBoxLabel>
            <DollarOutput value={expense.amountPaid} />
          </StyledMobileBoxLabel>
          <StyledMobileBoxItemRow>{expense.eventName}</StyledMobileBoxItemRow>
          <StyledMobileBoxItemRow>{expense.payerName}</StyledMobileBoxItemRow>
        </StyledMobileBoxItem>
      ))}
    </div>
  );
};

export default ExpensesMobile;
